import { jsxs as t, jsx as i } from "react/jsx-runtime";
import { c as r } from "../clsx-OuTLNxxd.js";
import { s } from "../FareInfographic.module-8nR033N7.js";
const c = e => e.inclusions.map(o => /* @__PURE__ */t("li", {
  className: r(s.step, {
    [s.disabled]: e.type == "disabled"
  }),
  children: [o.infographicTitle, o.footnote && /* @__PURE__ */i("div", {
    className: s.stepFootnote,
    children: o.footnote
  })]
}, o._id));
export { c as FareInfographicStep };